import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import classnames from 'classnames';
import css from './control-label.css';

const ControlLabel = ({ inverse, text, ...otherProps }) => (
  <div
    className={classnames(css['ds-control-label'], {
      [css['ds-control-label--inverse']]: inverse,
    })}
    {...otherProps}
  >
    {text}
  </div>
);

ControlLabel.defaultProps = {
  inverse: false,
  text: '',
};

ControlLabel.propTypes = {
  inverse: PropTypes.bool,
  text: PropTypes.string,
};

export default ControlLabel;
